import { QueryClientProvider } from '@tanstack/react-query';
import { Route, Switch } from 'wouter';
import { Layout } from '@/components/layout';
import { OverviewRoute } from '@/routes/overview';
import { ProxmoxRoute } from '@/routes/proxmox';
import { ServicesRoute } from '@/routes/services';
import { LauncherRoute } from '@/routes/launcher';
import { BaremetalRoute } from '@/routes/baremetal';
import { IntegrationsRoute } from '@/routes/integrations';
import { EventsRoute } from '@/routes/events';
import { ServiceDetailRoute } from '@/routes/service-detail';
import { LxcDetailRoute } from '@/routes/lxc-detail';
import { PelicanServerRoute } from '@/routes/pelican-server';
import { queryClient } from '@/lib/query';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Layout>
        <Switch>
          <Route path="/" component={OverviewRoute} />
          <Route path="/proxmox" component={ProxmoxRoute} />
          <Route path="/proxmox/lxc/:vmid" component={LxcDetailRoute} />
          <Route path="/services" component={ServicesRoute} />
          <Route path="/services/:id" component={ServiceDetailRoute} />
          <Route path="/integrations" component={IntegrationsRoute} />
          <Route path="/integrations/pelican/:id" component={PelicanServerRoute} />
          <Route path="/events" component={EventsRoute} />
          <Route path="/launcher" component={LauncherRoute} />
          <Route path="/baremetal" component={BaremetalRoute} />
          <Route>
            <div className="text-center text-muted-foreground py-12">
              404 — not found
            </div>
          </Route>
        </Switch>
      </Layout>
    </QueryClientProvider>
  );
}
